import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { ItemDetails } from './../../../_models/item/item-details.model';
import { ItemRequest } from './../../../_models/item/item-request.model';
import { AlertService, ItemServiceProvider, RequestHelperProvider } from './../../../_services/services';
import { Global } from 'src/app/globals';
import * as Sentry from '@sentry/angular';
import { Helpers } from 'src/app/_models/helpers';
import { ItemSearchType } from 'src/app/enums';
import { Subject } from 'rxjs';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from 'src/app/_services/loading.service';


@Component({
    selector: 'app-item-search',
    templateUrl: './item-search.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ],
})
export class ItemSearchComponent implements OnInit {
    private static readonly noOpSpan = { finish: () => undefined };

    itemRequest: ItemRequest = new ItemRequest();
    items: ItemDetails[] = [];
    currentWidth: number;

    @Output() sendResponseEventEmitter = new EventEmitter<any>();
    @Input() forSalesOrder: boolean;
    @Input() customerPriceLevel: string;
    @Input() itemSearchType: any;

    private cancelRequests$ = new Subject<boolean>();

    constructor(
        private alertService: AlertService,
        public globals: Global,
        private itemSerivce: ItemServiceProvider,
        private requestHelper: RequestHelperProvider,
        private router: Router,
        private route: ActivatedRoute, private blockUI: LoadingService) {
        this.currentWidth = window.innerWidth;

    }

    private startItemSearchSpan(name: string) {
        try {
            const sentryAny = Sentry as unknown as { startSpan?: (context: { name: string }) => { finish?: () => void } };
            const span = sentryAny.startSpan ? sentryAny.startSpan({ name }) : null;
            return span || ItemSearchComponent.noOpSpan;
        } catch {
            return ItemSearchComponent.noOpSpan;
        }
    }

    ngOnInit() {
        //this.moveSearchButton();
    }

    searchItem() {

        // Reset the cancelRequests$ subject for new requests
        this.cancelRequests$ = new Subject<boolean>();

        let transaction = this.startItemSearchSpan('Transaction:(Item Search)');
        this.alertService.clear();
        this.blockUI.start();

        if (this.itemRequest.id === '' && this.itemRequest.name === '' && this.itemRequest.categoryDescription === '') {
            this.blockUI.stop();
            return;
        }
        this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
            this.itemSerivce.searchItem(this.itemRequest, (response: any) => {
                transaction?.finish?.();
                if (response.length == 0) {
                    this.alertService.warning('No matching items found.');
                    this.items = [];
                    this.sendResponse();
                    this.blockUI.stop();
                } else {
                    this.blockUI.stop();
                    response.forEach(item => {
                        if (this.customerPriceLevel == '2')
                            item.price = item.priceLevel2;
                        else
                            item.price = item.priceLevel1;
                    });
                    this.items = response;

                    if (!this.items || this.items.length === 0) {
                        console.warn('No items to process.');
                        return;
                    }

                    this.sendResponse();

                }
            }, (error) => {
                transaction?.finish?.();
                this.blockUI.stop();
                console.log(error);
                Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                this.alertService.error(error.Code == 401 ? 'Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.' : error.Message);
            });
        }).catch((err) => {
            this.blockUI.stop();
            console.log(err);

        });

    }
    async sendResponse() {


        // for (let index = 0; index < this.items.length; index++) {
        //     const item = this.items[index];
        //     try {
        //         const balance = await this.itemSerivce.fetchItemBalanceRelational(this.itemSearchType, item);
        //         if (balance != null) {
        //             item.itemBalance = balance;
        //             item.isOnHandAndPositionLoaded = true;
        //         }
        //     } catch (ex) {
        //         item.isOnHandAndPositionLoaded = true;
        //         if (index == this.items.length - 1)
        //             this.blockUI.stop();
        //     }

        //     this.items[index] = item;

        // }

        // this.blockUI.stop();


        const arr: string[] = []; // Initialize an empty array

        this.items.forEach((i) => {
            arr.push(i.itemId); // Use push() to add elements           
        })

        // Convert to the required format ('abc','123','def')
        const formattedString = `(${arr.map(item => `'${item}'`).join(',')})`;

        this.itemSerivce.fetchItemBalanceByItemNumbersRelational(formattedString).then((balance) => {
            if (balance != null) {
                this.items.forEach((i) => {
                    // this will get the matching calnce of item                 
                    const matchingBalance = Array.isArray(balance)
                        ? balance.find(b => b.ItemNumber === i.itemId)
                        : balance.ItemNumber === i.itemId
                            ? balance
                            : null;

                    // default value will be set if matching balance not found
                    i.itemBalance = matchingBalance || { OnHandQuantity: 0, PositionQuantity: 0 };

                    // Mark as loaded
                    i.isOnHandAndPositionLoaded = true;
                });
            }
        })
            .catch(e => {
                this.items.forEach((i) => {
                    i.isOnHandAndPositionLoaded = true;
                });
            });


        if (this.itemSearchType != ItemSearchType.Items) {
            localStorage.setItem('BlockLocation', 'true');
        }
        this.sendResponseEventEmitter.emit(this.items);



        // // Cancel ongoing HTTP requests before starting new ones
        // this.requestHelper.cancelRequests();
        // this.cancelRequests$.next(true);
        // if (!this.items || this.items.length === 0) {
        //     console.error('No items to process.');
        //     return;
        // }

        // from(this.items)
        //     .pipe(
        //         mergeMap(
        //             (item) =>
        //                 from(this.itemSerivce.fetchItemBalanceRelational(this.itemSearchType, item)).pipe(
        //                     takeUntil(this.cancelRequests$), // Cancel if signal is emitted
        //                     catchError((error) => {
        //                         if (error.name === 'CanceledError' || error.message?.includes('canceled')) {
        //                             console.warn('Request canceled:', item);
        //                             return of(null); // Suppress cancellation errors
        //                         }
        //                         console.error('Error fetching item balance:', error);
        //                         //  Sentry.captureException(error); // Report actual errors
        //                         item.isOnHandAndPositionLoaded = true;
        //                         return of(null); // Continue with default behavior
        //                     }),
        //                     map((balance) => {
        //                         item.itemBalance = balance ? (balance as ItemBalance) : null;
        //                         item.isOnHandAndPositionLoaded = true;
        //                         return item;
        //                     }), filter(item => !!item) // Skip null values if appropriate
        //                 ),
        //             2 // Concurrency limit
        //         ),
        //         finalize(() => {
        //             console.log('Processing complete or canceled.');
        //             this.sendResponseEventEmitter.emit(this.items); // Clear UI or trigger update
        //         })
        //     )
        //     .subscribe(
        //         (updatedItem) => {
        //             // Emit the updated item immediately
        //             this.items = this.items.map((i) =>
        //                 i === updatedItem ? updatedItem : i
        //             );
        //             this.sendResponseEventEmitter.emit(this.items);
        //         },
        //         (error) => {
        //             console.error('Unexpected error in processing pipeline:', error);
        //             //  Sentry.captureException(error); // Capture unexpected pipeline errors
        //         },
        //         () => {
        //             console.log('All items processed or canceled');
        //         }
        //     );




    }
    // moveSearchButton() {
    //     var inputFieldWidth = 0;
    //     var searchButtonWidth = 0;
    //     var totalWidth = 0;
    //     var field;

    //     field = document.getElementById("divItemSearch");
    //     if (this.currentWidth < 768) {
    //         field.setAttribute("hidden", "true");
    //     }
    //     else {
    //         field.removeAttribute("hidden");

    //         field = document.getElementById("inputItemFields");
    //         inputFieldWidth = field.offsetWidth;

    //         field = document.getElementById("searchItemButton");
    //         //if (field != null){
    //         searchButtonWidth = field.offsetWidth;

    //         var totalWidth = inputFieldWidth - searchButtonWidth;

    //         field = document.getElementById("leftItemSpace");
    //         field.setAttribute("style", "margin-left: " + totalWidth.toString() + "px");
    //         //}
    //     }
    // }

    onResize(event) {
        //this.currentWidth = window.innerWidth;
        this.currentWidth = event.target.innerWidth;
        //console.log("width:" + window.innerWidth);

        //this.moveSearchButton();
    }
    onEnter() {
        if (this.itemRequest.id == '' && (this.itemRequest.name == '' || this.itemRequest.name.length < 1) && (this.itemRequest.categoryDescription == '' || this.itemRequest.categoryDescription.length < 3)) {
            return;
        } else {
            this.searchItem();
        }
    }

    openBookingsComplete() {
        Helpers.LogInfo("before navigation", "openBookingsComplete");

        //  location.href = "bookingcomplete?mode=Order;bookingReceiptNumber=18666";   
        ///bookingcomplete;mode=Book;Btn=BOOKING;bookingReceiptNumber=19640

        this.router.navigate(['bookingcomplete', { mode: 'Book', Btn: 'booking', bookingReceiptNumber: '19640' }]);
    }

    cancelRequests() {

        console.log('Triggering cancellation from ItemSearchComponent.');
        this.cancelRequests$.next(true);
        this.requestHelper.cancelRequests();
    }

    ngOnDestroy() {
        this.requestHelper.destroy();
    }
}
